export const STUDIO_MIGRATION_COPY = {
  title: 'Moving you to Unlimited',
  subtitle:
    'Studio is closing, so we\'re bringing your account across. Confirm your Unlimited email and we\'ll move your Sessions and credits over.',
  emailLabel: 'Your Unlimited email',
  emailPlaceholder: 'you@email.com',
  filesCheckbox: 'Also bring my Session files across',
  warning: 'This is done by hand, so it can take a few days. We\'ll email you once everything\'s moved.',
  commentsLabel: 'Anything we should know? (optional)',
  commentsPlaceholder: 'Optional',
  submitLabel: 'Confirm migration',
  submittingLabel: 'Sending...',
  success: 'Done. We\'ll move everything across and email you once it\'s ready.',
  error: 'Something went wrong sending your request. Please try again.'
};
